var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.91288 8.995C5.7804 8.97711 5.65625 8.92033 5.5596 8.83321L0.226837 4.05401C0.0926838 3.94822 0.0101995 3.79498 0.00102711 3.63085C-0.00897121 3.46595 0.0543537 3.30571 0.176007 3.18591C0.296828 3.0669 0.465981 3 0.641792 3C0.818441 3.00078 0.986758 3.06923 1.10675 3.18902L5.99966 7.57612L10.8926 3.18902C11.0134 3.06923 11.1817 3.00078 11.3575 3C11.5342 3 11.7025 3.0669 11.8241 3.18591C11.945 3.3057 12.0083 3.46593 11.9991 3.63085C11.9891 3.79498 11.9075 3.94823 11.7725 4.05401L6.43972 8.83321C6.29974 8.95922 6.10642 9.01834 5.9131 8.995H5.91288Z",
    fill: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.4b580f155a95d71d4bac1db7c8fc0db5.svg";
export { ForwardRef as ReactComponent };